export default "__VITE_ASSET__CsbEX6yK__"